module.exports = __webpack_public_path__ + "img/radio-dark.e0b79a0b.jpg";